module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Union-bb4fc0bd3b78410027c22c9545489cea794f03af58450c03976c588390a1140c.svg";